export const LocaleFR = {
  mixed:{
    default: 'est invalide.',
    required: 'est un champ obligatoire',
    oneOf: "doit être l'une des valeurs suivantes: ${values}",
    notOneOf: "ne doit pas être l'une des valeurs suivantes: ${values}",

  },
  string: {
    length: 'doit être exactement ${length} caractères 🤔',
    min: 'doit être au moins ${min} caractères',
    max: 'doit être au plus ${max} caractères',
    matches: "n'est pas conforme 🙄",
    email: 'doit être un email valide 🙄',
    url: 'doit être une URL valide',
    trim: 'doit être une chaîne garnie',
    lowercase: 'doit être une chaîne en minuscule 🙄',
    uppercase: 'doit être une chaîne de majuscules',
  },
  number:{
    min: 'doit être supérieure ou égale à ${min}',
    max: 'doit être inférieur ou égal à ${max}',
    lessThan: 'doit être inférieure à ${less}',
    moreThan: 'doit être supérieure à ${more}',
    positive: 'doit être un nombre positif',
    negative: 'doit être un nombre négatif',
    integer: 'doit être un entier',
  },
  date:{

    min: 'champ doit être au plus tard ${min}',
    max: 'champ doit être au plus tôt ${max}',
  },
  array: {
    min: 'champ doit avoir au moins ${min} articles',
    max: 'champ doit avoir inférieur ou égal à ${max} articles',
  }
}






